export enum ActionTypes {
  ADD_QUESTION_DETAILS = "app/qa/ADD_QUESTION_DETAILS",
  CLEAR_QUESTION_DETAILS = "app/qa/CLEAR_QUESTION_DETAILS",
}
